export const SITE_URL = window.location.origin;
export const SALUTATIONS = ["", "Frau", "Herr"];
